import {
  OpenAPIConfig,
  IntegrationServicesClient,
} from '@resideo/web-integration-services-api-client';
import { RIS_BASE_URL } from 'config';
import { useAuth } from 'utils/auth';
import { BinaryAwareFetchHttpRequest } from '../utils/BinaryAwareFetchHttpRequest';

export const useRisClient = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth();

  const config: Partial<OpenAPIConfig> = {
    BASE: RIS_BASE_URL,
    TOKEN: async () => {
      return isAuthenticated ? await getAccessTokenSilently() : '';
    },
  };

  return {
    client: new IntegrationServicesClient(config, BinaryAwareFetchHttpRequest),
  };
};
